import axios from 'axios';
import API_ROUTES from '../../routes/ApiRoutes.js';

// Obtener el registro por id
export const getMultimediaLevelById = async (id) => {
    const { data } = await axios.get(`${API_ROUTES.MULTIMEDIA_LEVELS}/${id}`);
    return data;
};

// procedimiento actualizar
export const updateMultimediaLevel = async (id, payload) => {
    const { data } = await axios.put(`${API_ROUTES.MULTIMEDIA_LEVELS}/${id}`, payload);
    return data;
};